<template>
	<div id="app" class='row zero_margin' style='overflow:hidden'>
		<div v-if="currentPage && currentPage != 'login'" class="nav_wrapper elementToFadeInAndOut" @mouseover="showNavigationicon()" :class="openDrawer?'updateWidth':(showHoverNavigation?'updateWidth nav_hover':'')">
			<NavigationMenu  v-if="(currentPage != 'login' && currentPage != 'mapping')"
		/>
		</div>
		<div v-if="currentPage && currentPage != 'login'" class="main_right_wrapper" @mouseover="hideNavigation()" :class="openDrawer?'updateWidth':(showHoverNavigation?'nav_hover':'')">
			<routerView></routerView>
		</div>
		<div v-else style="width:100%">
			<routerView></routerView>
		</div>
	</div>
</template>

<script>
	import NavigationMenu from "@/components/NavigationMenu";
	import MainHeader from "@/components/MainHeader";
	import MainFooter from "@/components/MainFooter";
	import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
	import NewLogin from "@/components/NewLogin/Login.vue"


	export default {
		name: "App",
		components: {
			MainHeader,
			MainFooter,
			NavigationMenu,
			NewLogin
		},
		data(){
			return{
			}
		},

  watch: {
    '$route' (to, from) {
		  $(window).scrollTop(0);
		//  this.resetCommonStoreState()
       if (to.name == 'productList' && !this.$store.state.calledFromCancel && from.name != 'addEditProduct' && from.name != 'addNewProduct' && from.name !='addToCampaign' && from.name != 'addNewCampaign') {
					this.resetCommonStoreState()
	        this.$store.state.product.selectedProducts = [];
	        this.$store.state.product.actionSelectionControl = false;
	        this.$store.state.product.productList = [];
      }
	  if (to.name == 'productList' && !this.$store.state.calledFromCancel && from.name == 'addEditProduct') {
		   this.$store.state.product.selectedProducts = [];
		   this.$store.state.product.actionSelectionControl = false;
		   this.$store.state.product.productList = [];
		   this.resetProduct()
	 }
      if (to.name == 'campaignGroupList' && from.name != 'campaignListPerGroup' && from.name !='activityList' && from.name !='addGuardrail') {
		  	if(from.name=='addEditGuardrail' && this.$store.state.calledFromCancel){
				  //do nothing
			}
			else{
				this.resetCommonStoreState()
				this.selectedPage == 'CampaignGroup'
				sessionStorage.removeItem('campaign:selectedCampaignGroupFilter');
				sessionStorage.removeItem('campaign:selectedVendorFilter');
			}

      }
	  if(to.name == 'campaignList' && !this.$store.state.calledFromCancel){
		 //  this.fetchFilterValuesFromSession();
		// this.$store.state.searchFilterString = ''
	  }
	  if(to.name != 'campaignList' && !this.$store.state.calledFromCancel){
		 //  this.fetchFilterValuesFromSession();
		// this.resetCommonStoreState();
	  }
	  if(to.name == 'campaignList' && from.name == 'campaignListPerGroup' && !this.$store.state.calledFromCancel){
		   this.resetCommonStoreState();
		   this.$store.dispatch("campaign/getCampaignList")

    }
	if( to.matched[0].path == "/campaignList/:groupId" && from.name != 'campaignGroupList'){
		 this.resetCommonStoreState();
	}
    if(to.name == 'campaignList' && from.name == 'campaignGroupList'  && !this.$store.state.calledFromCancel){
      this.resetCommonStoreState();
    }
	if(to.name == 'campaignList'){
		this.$store.state.campaign.actionSelectionControl = false
		this.$store.state.campaign.campaignSelectedList = []
		this.$store.state.campaign.campaignToAddToGroupList = []
		// this.$store.state.campaign.advanceFilter = {};
	}
	if((to.name == 'accounts') &&  !this.$store.state.calledFromCancel){
		const tempSortOrder = this.$store.state.selectedSortOrder
		this.resetAccountsData()
		if(from.name=='addVendor'){
			this.$store.state.selectedSortOrder = tempSortOrder
		}
	}
	if((from.name == 'accounts') &&  (to.name == 'campaignList')){
		this.resetAccountsData()
	}
	if(to.name == 'notification'){
		this.resetCommonStoreState()
		this.resetNotification()
	}
	if(from.name == 'notification'){
		this.resetNotification()
	}
	if(from.name == 'asinScraper' &&  !this.$store.state.calledFromCancel){
		this.resetCommonStoreState()
	}
	if(to.name == 'asinScraper'){
		this.$store.state.product.actionSelectionControl = false;
		this.$store.state.product.selectedProducts = []
		this.resetCommonStoreState()
	}
	if(from.name == 'Automation2' || to.name == 'Automation2'){
		this.resetCommonStoreState()
	 }
   if(from.name == 'campaignGroupList'){
	  $('#editCampaign').modal('hide')
	  window.history.forward(1)
     }
    if(to.name == 'KeywordDetail'){
		let tempFilter = this.$store.state.selectedVendorFilter
		let tempFilterString = this.$store.state.searchFilterString
		let tempBrandFilter = this.$store.state.selectedBrandProfle
		let tempClientFilter = this.$store.state.clientData
		let tempCampGrpFilter = this.$store.state.selectedCampaignGroupFilter
		let tempSortOrder = this.$store.state.selectedSortOrder
		let tempTagId = this.$store.state.selectedTag
		const tempCampPageNumber = this.$store.state.currentPageNumber
		this.resetCommonStoreState()
		if(from.name == 'campaignList'){
			this.$store.state.currentPageNumber = tempCampPageNumber
		}
		this.$store.state.selectedVendorFilter = tempFilter
		this.$store.state.searchFilterString = tempFilterString
		this.$store.state.selectedBrandProfle = tempBrandFilter
		this.$store.state.clientData = tempClientFilter
		this.$store.state.selectedCampaignGroupFilter = tempCampGrpFilter
		this.$store.state.selectedSortOrder = tempSortOrder
		this.$store.state.selectedTag = tempTagId
	 }
	if(from.name == 'accounts'){
		$('#downloadFile').modal('hide')
		window.history.forward(1)
	}

	if(to.name == 'accounts' && from.name != 'addVendor' && from.name != 'editBrand' &&  !this.$store.state.calledFromCancel){
		this.resetFilterForAccount()
	}

	if(from.name == 'accounts' && to.name != 'addVendor' && to.name != 'editBrand' && to.name != 'accountDetails'){
		this.resetFilterForAccount()
	}
	if(to.name == 'campaignList' && from.name == 'productList' && !this.$store.state.calledFromCancel){
		this.resetCommonStoreState()
	}
	if(to.name == 'campaignList' && (from.name == 'accounts' || from.name == 'productList' || from.name == 'campaignGroupList' || from.name == 'notification' || from.name == 'asinScraper' || from.name == 'Automation2')){
		this.resetAdvanceFilter()
	}
	if(to.name == 'accounts' && (from.name == 'campaignList' || from.name == 'productList' || from.name == 'campaignGroupList' || from.name == 'notification' || from.name == 'asinScraper' || from.name == 'Automation2')){
		this.resetAdvanceFilter()
	}
	if(from.name == 'campaignList' && (to.name == 'accounts' || to.name == 'productList' || to.name == 'campaignGroupList' || to.name == 'notification' || to.name == 'asinScraper' || to.name == 'Automation2')){
		this.resetAdvanceFilter()
	}
	if(from.name == 'accounts' && (to.name == 'campaignList' || to.name == 'productList' || to.name == 'campaignGroupList' || to.name == 'notification' || to.name == 'asinScraper' || to.name == 'Automation2')){
		this.resetAdvanceFilter()
	}
	if(from.name=='campaignGroupList' && to.name=='campaignListPerGroup'){
		this.$store.state.tempCampGrpPageNo  = JSON.parse(JSON.stringify(this.$store.state.currentPageNumber ||1))
		this.$store.state.tempCampGrpShowPerPage  = sessionStorage.getItem("campaign:showPerPage"),
		this.resetFooter()
	}
	if(to.name=='campaignGroupList' && from.name=='campaignListPerGroup'){
		this.$store.state.currentPageNumber  = JSON.parse(JSON.stringify(this.$store.state.tempCampGrpPageNo || 1))
		sessionStorage.setItem("campaign:showPerPage",(this.$store.state.tempCampGrpShowPerPage || 25))
		this.$store.state.tempCampGrpPageNo = 1
		this.$store.state.tempCampGrpShowPerPage = 25
		this.$store.state.selectedSortOrder = {field:'name',order:'asc'}
	}
	if(from.name=='addToCampaign' || to.name =='addToCampaign'){
		this.$store.state.campaign.selectedAssociateFilter = 'All';
	}
	if(to.name == 'productList' && (from.name == 'campaignList' || from.name == 'accounts' || from.name == 'campaignGroupList' || from.name == 'notification' || from.name == 'asinScraper' || from.name == 'Automation2')){
		this.resetAdvanceFilter()
	}
	if(from.name == 'productList' && (to.name == 'accounts' || to.name == 'campaignList' || to.name == 'campaignGroupList' || to.name == 'notification' || to.name == 'asinScraper' || to.name == 'Automation2')){
		this.resetAdvanceFilter()
	}
	if(to.name == 'campaignGroupList'){
		 this.$store.state.campaign.actionSelectioncampaignGroupControl = false
     this.$store.state.campaign.campaignGroupSelectedList = []
	}
	if(from.name=='Automation2' || to.name=='Automation2'){
		this.$store.state.automation.target = 'All'
	}
	if(from.name=='recommendKeyword' || to.name=='recommendKeyword'){
		this.$store.state.recommendedKeywordShowPerPage = 25
		sessionStorage.setItem("keyword:recommendedKeywordShowPerPage", 25);
		this.$store.state.recommendedKeywordCurrentPageNumber = 1
		this.$store.state.recommendedTotalKeywordCount = 0
	}

    }
  },
  beforeMount(){
	 // this.fetchFilterValuesFromSession();
	//if user had come through our specific link then despite if the link changes during the session we want to persist our state	
	if(this.$route.query.profile==this.$store.state.campaign.prestigeProfileId 
	// || sessionStorage.getItem('isUserPrestige')
	){
      //loads the global state into the sessionStorage so that the state persists even after a refresh
		// sessionStorage.setItem('isUserPrestige',true);
		let prestigeId = this.$store.state.campaign.prestigeProfileId
		this.$store.state.isUserPrestige=true;
		this.$store.commit("setSelectedBrandProfile",prestigeId);

}
    if(this.$route.query.untagged && this.$route.query.untagged=="true" 
	// && !sessionStorage.getItem('getUntagged')
	){
		this.$store.state.campaign.getUntagged=true;
		// sessionStorage.setItem('getUntagged',true);
	}
  },
  mounted(){
	  this.openDrawer = (sessionStorage.getItem('openDrawer')||'').toString()=="false" ? false : true
  },
  created () {
//	 this.timer = setInterval(this.logOutSession, 3000000)
	// this.timer = setInterval(this.logOutSession, 30000)
  },
  methods: {
		hideNavigation() {
			this.showHoverNavigation = false;
			this.renderDelayVariable = false;
			
			if (this.openDrawer) {
				return;
			}
		},
		showNavigationicon(){
			if(this.openDrawer){
				this.destroyDelayVariable = true;
			}
			if(!this.openDrawer){
				// this.renderDelayVariable = false
				return ;
			}
			this.showHoverNavigation = true
		},
		resetNotification(){
			this.$store.state.selectedLastXDays = "";
			this.$store.state.selectedVendorNotification='';
			this.$store.state.searchFilterString='';
			this.$store.state.showPerPage='25';
			this.$store.state.currentPageNumber = 1;
		},
		resetFooter(){
			this.$store.state.currentPageNumber = 1
			sessionStorage.setItem("campaign:showPerPage",25);
		},
	  // logOutSession(){
		//   let loginDate = sessionStorage.getItem("loginDate")
		//   let todaysdate = new Date();
		//   todaysdate = todaysdate.toDateString()
	  //
		//   if(todaysdate != loginDate){
		// 	  var data = {
		// 		  UserPoolId : 'us-east-1_KPh2ycnq4', // Your user pool id here
		// 		  ClientId : '1qe6ml4g9dh4c1sl5j99k8965j' // Your client id here
		// 	  };
	  //
		// 	  var userPool = new AmazonCognitoIdentity.CognitoUserPool(data);
	  //
		// 	  var userData = {
		// 			Username : JSON.parse(window.sessionStorage.getItem('session')).username, //'kjoshi@contata.com',
		// 			Pool : userPool
		// 		};
		// 	  var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
		// 	//  AWS.config.credentials = new CognitoIdentityCredentials(cognitoUser)
		// 	  cognitoUser.signOut();
		// 	  sessionStorage.clear();
		// 	  window.location.reload();
		//   }
	  //
	  //
	  //
		// },
		resetAdvanceFilter(){
			this.$store.state.campaign.advanceFilter = {}
			this.$store.state.accountsFilter = []
			this.$store.state.accounts.advanceFilter = {}
			this.$store.state.campaignsFilter = []
			this.$store.state.productAdvanceFilter = []
			this.$store.state.product.productAdvanceFilter = {}
			this.$store.state.campaign.prestigeAdvanceFilter = {}
		},
	  fetchFilterValuesFromSession(){
		//  storage.removeItem("campaign:selectedVendorFilter");
		  sessionStorage.removeItem("campaign:selectedCampaignGroupFilter");
		 if (sessionStorage.getItem("campaign:selectedVendorFilter")) {
		  	this.$store.commit('setSelectedVendorFilter', sessionStorage.getItem("campaign:selectedVendorFilter"))
		 }
		 // if (sessionStorage.getItem("campaign:selectedBrandProfle")) {
		 //     this.$store.commit('setSelectedBrandProfile', sessionStorage.getItem("campaign:selectedBrandProfle"))
		 // }
	 },
    resetCommonStoreState() {
	  this.$store.state.selectedTag = ''
	  this.$store.state.listOfTags=[]
	  this.$store.state.clientData = null
      this.$store.state.selectedBrandProfle = ''
      this.$store.state.selectedCampaignGroupFilter = ''
      this.$store.state.selectedVendorFilter = ''
      this.$store.state.selectedSortOrder = ''
      this.$store.state.searchFilterString = ''
      this.$store.state.currentPageNumber = 1
	  this.$store.state.showPerPage = 25
	  this.$store.state.selectedVendorProduct = ''
	  this.$store.state.selectedBrandProduct = ''
      this.$store.state.selectedAccountContactFilter = ''
	  this.$store.state.campaign.campaignToAddToGroupList = [];
	  // this.$store.state.campaign.advanceFilter = {};
	//   this.$store.state.automation.owner = 'Me';
	  this.$store.state.searchKeywordFilterString = '';
	  this.$store.state.campaign.actionSelectionControl = '';
	  this.$store.state.selectedVendorPartnerUuid = ''


    },
  resetProduct(){
	  this.$store.state.clientData = null
	  this.$store.state.selectedBrandProfle = ''
	  this.$store.state.selectedCampaignGroupFilter = ''
	  this.$store.state.selectedVendorFilter = ''
	  this.$store.state.selectedSortOrder = ''
	  this.$store.state.searchFilterString = ''
	  this.$store.state.currentPageNumber = 1
	  this.$store.state.showPerPage = 25
	  this.$store.state.campaign.campaignToAddToGroupList = [];
	   this.$store.state.campaign.actionSelectionControl = '';
  },
  resetFilterForAccount(){
	  // this.$store.state.accounts.advanceFilter = {};
	  this.$store.state.selectedClientFilter = ''
	  this.$store.state.searchFilterString = ''

  },
   resetAccountsData(){
	   this.$store.state.clientData= null,
	    this.$store.state.selectedBrandProfle = ''
	    this.$store.state.selectedCampaignGroupFilter = ''
	    this.$store.state.selectedVendorFilter = ''
	    this.$store.state.selectedSortOrder = ''
	    this.$store.state.currentPageNumber = 1
		this.$store.state.showPerPage = 25
		this.$store.state.selectedVendorProduct = ''
		this.$store.state.selectedBrandProduct = ''
	    this.$store.state.selectedAccountContactFilter = ''
		this.$store.state.campaign.campaignToAddToGroupList = [];
		// this.$store.state.campaign.advanceFilter = {};
		this.$store.state.automation.owner = 'Me';
		 this.$store.state.campaign.actionSelectionControl = '';
		this.$store.state.selectedVendorPartnerUuid = ''
   }
  },
  computed: {
	renderDelayVariable:{
      set(val){
        this.$store.state.renderDelayVar = val;
      },
      get(){
        return this.$store.state.renderDelayVar;
      }
    },
	destroyDelayVariable:{
      set(val){
        this.$store.state.destroyDelayVar = val;
      },
      get(){
        return this.$store.state.destroyDelayVar ;
      }
    },
	showHoverNavigation :{
      set(val){
        this.$store.state.showHoverNavigation = val
      },
      get(){
        return this.$store.state.showHoverNavigation
      }
    },
	openDrawer: {
      set(val) {
        sessionStorage.setItem('openDrawer',val)
        this.$store.state.openDrawer = val;
      },
      get() {
        return this.$store.state.openDrawer;
      },
    },
    currentPage() {
      return this.$route.name
    },
    selectedPage: {
      set(val) {
        this.$store.state.selectedPage = val
      },
      get() {
        return this.$store.state.selectedPage
      }
    }
  }
}
</script>
<style lang="scss">
.elementToFadeInAndOut {
	.fade_in{
		-webkit-animation: fadein 0.5s linear forwards;
    	animation: fadein 0.5s linear forwards;
	}
	.fade_out{
		-webkit-animation: fadeout 0.5s linear forwards;
    	animation: fadeout 0.5s linear forwards;
	}
}



@-webkit-keyframes fadein {
  0%,20% { opacity: 0;}
  20%,50% {opacity:0.8;}
  50%,100% { opacity: 1}
}

@keyframes fadeout {
  0%,20% { opacity: 1; }
  20%,50% { opacity: 0.5}
  50%,100% { opacity: 0; }
}
.main_right_wrapper{
	width:calc(100% - 95px);
	// padding-left:25px;
	background-color:white;margin-left:95px !important;
	@media (max-width :768px) {
		width:calc(100% - 60px);
		margin-left:60px !important;
	}
}
.main_right_wrapper.nav_hover{
}
.main_right_wrapper.updateWidth{
	// width:80% !important;
	width: calc(100% - 275px) !important;
	margin-left: 275px !important;
	// margin-left:20% !important;
}
.zero_margin{
	margin-left:0px !important;
	margin-right:0px !important;
}
.login_wrapper{
	
	height: calc(100vh) !important;
	width:100%;height:100%;border: 1px solid #979797;
  	background-color: #115E67;
	padding-left:20px;
	padding-right:20px;
	padding-top:calc((100vh - 700px)/2);
	padding-bottom:calc((100vh - 700px)/2);
//   padding-left: calc((100% - 1024px)/2);
//   padding-right: calc((100% - 960px)/2);
	@media (min-width:1387px) and (min-height:850px){
		padding-top:calc((100vh - 830px)/2);
		padding-bottom:calc((100vh - 830px)/2);
	}
  @media (max-width:1024px) and (max-height:1367px) and (orientation:portrait){
	padding: 27px 39px ; 
	height: calc(100vh) !important;
  }
  @media all and (max-width: 768px) and (max-height: 1024px) and (orientation:portrait) {
	 padding-top: 30px !important;
	//  height: calc(100vh) !important;
  }
  @media (max-width:480px) {
	  padding: 0px !important;
	//   height: calc(100vh) !important;
  }
}
.nav_wrapper{
	position:fixed;
	width:95px;
	padding-right:25px;
	height:calc(100vh);
	transition:0.3s;
	z-index: 2;
	@media (max-width :768px) {
		width:60px !important;
	}
}
.nav_wrapper.updateWidth{
	width:275px !important;
	// width:20% !important;
	@media (max-width :768px) {
		width:100% !important;
	}
}
.nav_wrapper.nav_hover{
	position: fixed;
	z-index:99;
}
.btn {
	margin: 5px;
}
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */
.table {
	.row-add-edit {
		.grid-item {
			cursor: pointer;
		}
	}
}
.table thead th{
	font-weight: 600;
}
.multiselect__tags {
	border: none !important;
	padding:8px 40px 0 8px !important;
}
.multiselect__tag {
	background: #115E67 !important;
}
.multiselect.form-control {
	padding: 0;
	height: calc(1.5em + 0.75rem + 6px);
}
.back-icon-wrap {
	font-size: 18px;
	margin-right: 8px;
	line-height: 1.7;
	cursor: pointer;
}
.multiselect.form-control.multi-dropdown {
	padding: 0;
	min-height: calc(1.5em + 0.75rem + 6px);
	height: auto;
}
.guard_css{
	.bold_arrow{
		.multiselect.form-control.select_filter{
			.multiselect__select:before{
				top: 70% !important;
				color: #000000 !important;
				border-color: #000000 transparent transparent !important;
				border-width: 8px 7px 0px !important;
			}
		}
	}
}
.main_head_block{
	.multiselect.form-control.select_filter{
		box-sizing: border-box;
		min-height: 43px;
		min-width:220px;
		border: 1px solid #979797;
		border-radius: 6px;
		background-color: #FFFFFF;
		
		.multiselect__content-wrapper{
			.multiselect__content{
				.multiselect__element{
					.multiselect__option--highlight{
						background:#115E67 !important;
					}
					.multiselect__option--highlight::after{
						background:#115E67 !important;
					}
				}
			}
			
		}
		
	}
}
.main_form_block{
	.multiselect.form-control.select_filter{
		// box-sizing: border-box;
		// min-height: 43px;
		// min-width:220px;
		// border: 1px solid #979797;
		// border-radius: 6px;
		// background-color: #FFFFFF;
		.multiselect__content-wrapper{
			.multiselect__content{
				.multiselect__element{
					.multiselect__option--highlight{
						background:#115E67 !important;
					}
					.multiselect__option--highlight::after{
						background:#115E67 !important;
					}
				}
			}
			
		}
		
	}
}
.b-calendar-nav {
    background: aliceblue;
    border-right: 1px solid rgba(0, 0, 0, 0.15);
}
#datePicker__value_, #start__value_{
	border:0px;
	margin:0px
}

.no-data-style{
    font-size: 80%;
    color: #dc3545
}
.bread-crumb-small{
	font-size: 16px !important
}
.table-responsive {
	.label {
		display: inline;
		padding: 0.2em 0.6em 0.3em;
		font-size: 75%;
		font-weight: 700;
		line-height: 1;
		color: #fff;
		text-align: center;
		white-space: nowrap;
		vertical-align: baseline;
		border-radius: 0.25em;
	}
}
.table-responsive {
	.label-info {
		background-color: #5bc0de;
	}
}
.table-responsive {
	tr {
		 td {
			padding-left: 12px;
			padding-right: 8px;
		 }
	}
}
.dropdown-menu{
	min-width: 14rem !important;
}




</style>
